import React, { Component } from 'react';
import EWH from '../components/EWH';
//import { Link } from 'react-router-dom';
//import { Form } from 'react-bootstrap';
export class HomeElezioni extends Component {
  render() {
    return (
	    <div className="App">
	    	<EWH id="ewh-fascione-hp-elezioni" title="Fascione HP Elezioni" repo='/elezioni/withub/comunali-2026/comunali-ballottaggio/fascione-composto.html?cid=ewh-fascione-hp-elezioni&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
    </div>
    )
  }
}

export default HomeElezioni
